import CustomerOrderHistory from './CustomerOrderHistory'

export * from './CustomerOrderHistory'

export default CustomerOrderHistory
